var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7503 46.375H17.667V17.6667L33.1253 2.20834L35.8857 4.96876C36.1434 5.2264 36.3554 5.57605 36.5217 6.01772C36.6881 6.45939 36.7705 6.88265 36.7691 7.28751V8.06043L34.3399 17.6667H46.3753C47.5531 17.6667 48.5837 18.1083 49.467 18.9917C50.3503 19.875 50.792 20.9056 50.792 22.0833V26.5C50.792 26.7577 50.7648 27.0337 50.7103 27.3281C50.6558 27.6226 50.5726 27.8986 50.4607 28.1563L43.8357 43.725C43.5045 44.4611 42.9524 45.0868 42.1795 45.6021C41.4066 46.1174 40.5969 46.375 39.7503 46.375ZM13.2503 17.6667V46.375H4.41699V17.6667H13.2503Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.1e0d994e4bc7246ee018880d267f98ad.svg";
export { ForwardRef as ReactComponent };